// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMSheet.tsx — PropelMapper standardized bottom sheet (the primary modal).
//
// Scrim rgba(0,0,0,0.4) + top-rounded white panel that slides up on the iOS
// curve (cubic-bezier(0.32,0.72,0,1)) with a 36×4 drag-handle pill — exactly
// the motion documented in the design system. Composes a header (title +
// optional subtitle + close), a scrollable body (children), and an optional
// footer (pass a <PMFormActions/>).
//
// Renders absolutely-positioned, filling its nearest positioned ancestor — so
// inside a phone frame it covers just the screen. Pass open={false} to unmount.

function pmEnsureOverlayKeyframes() {
  if (typeof document === "undefined") return;
  if (document.getElementById("pm-overlay-kf")) return;
  const el = document.createElement("style");
  el.id = "pm-overlay-kf";
  el.textContent =
    "@keyframes pmScrimIn{from{opacity:0}to{opacity:1}}" +
    "@keyframes pmSheetUp{from{transform:translateY(100%)}to{transform:translateY(0)}}" +
    "@keyframes pmDialogIn{from{opacity:0;transform:scale(.96) translateY(8px)}to{opacity:1;transform:none}}" +
    "@media (prefers-reduced-motion: reduce){" +
    ".pm-anim-scrim,.pm-anim-sheet,.pm-anim-dialog{animation:none!important}}";
  document.head.appendChild(el);
}

function PMCloseGlyph({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function PMSheet({
  open = true,
  title,
  subtitle,
  onClose,
  children,
  footer = null,
  maxHeight = "88%",
  dismissOnScrim = true,
  showClose = true,
  zIndex = 60,
  style = {},
}: any) {
  pmEnsureOverlayKeyframes();
  if (open === false) return null;

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        zIndex,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        fontFamily: "var(--pm-font-sans)",
      }}
    >
      <div
        className="pm-anim-scrim"
        onClick={dismissOnScrim ? onClose : undefined}
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.4)",
          animation: "pmScrimIn 200ms ease",
        }}
      />

      <div
        className="pm-anim-sheet"
        role="dialog"
        aria-modal="true"
        aria-label={title || "Sheet"}
        style={{
          position: "relative",
          background: "var(--pm-surface)",
          borderRadius: "var(--pm-radius-xxl) var(--pm-radius-xxl) 0 0",
          maxHeight,
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 -8px 30px rgba(0,0,0,0.18)",
          animation: "pmSheetUp 320ms cubic-bezier(0.32,0.72,0,1)",
          ...style,
        }}
      >
        {/* Drag handle */}
        <div style={{ display: "flex", justifyContent: "center", padding: "8px 0 4px", flexShrink: 0 }}>
          <div style={{ width: 36, height: 4, borderRadius: 999, background: "var(--pm-border)" }} />
        </div>

        {/* Header */}
        {(title || showClose) && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 12,
                padding: "6px 16px 14px",
                flexShrink: 0,
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                {title && (
                  <div style={{ font: "700 18px/1.25 var(--pm-font-sans)", color: "var(--pm-fg-1)", letterSpacing: "-0.2px" }}>
                    {title}
                  </div>
                )}
                {subtitle && (
                  <div style={{ marginTop: 3, font: "400 13px/1.4 var(--pm-font-sans)", color: "var(--pm-fg-3)" }}>
                    {subtitle}
                  </div>
                )}
              </div>
              {showClose && (
                <button
                  onClick={onClose}
                  aria-label="Close"
                  style={{
                    flexShrink: 0,
                    width: 30,
                    height: 30,
                    borderRadius: 999,
                    border: "none",
                    cursor: "pointer",
                    background: "var(--pm-surface-variant)",
                    color: "var(--pm-fg-2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PMCloseGlyph />
                </button>
              )}
            </div>
            <div style={{ height: 1, background: "var(--pm-border-light)", flexShrink: 0 }} />
          </>
        )}

        {/* Body */}
        <div style={{ flex: 1, minHeight: 0, overflowY: "auto", padding: "16px" }}>{children}</div>

        {/* Footer */}
        {footer && (
          <div
            style={{
              padding: "12px 16px calc(16px + env(safe-area-inset-bottom, 10px))",
              borderTop: "1px solid var(--pm-border-light)",
              flexShrink: 0,
            }}
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
